import ApplicationReviewersTab from './application-reviewers.vue'
import CertificateManagersTab from './certificate-managers.vue'
import FollowUpManagersTab from './follow-up-managers.vue'
import AuditTeamTab from './audit-team.vue'
import TechnicalReviewersTab from './technical-reviewers.vue'
import DecisionMakerTab from './decision-maker.vue'

const ASSIGN_PERSONAL_TABS = [
  {
    key: 'application-reviewers',
    label: 'Application Reviewers',
    icon: 'UserCheckIcon',
    component: ApplicationReviewersTab,
  },
  {
    key: 'certificate-managers',
    label: 'Certificate Managers',
    icon: 'AwardIcon',
    component: CertificateManagersTab,
  },
  {
    key: 'decision-maker',
    label: 'Decision Maker',
    icon: 'CheckSquareIcon',
    component: DecisionMakerTab,
  },
  {
    key: 'follow-up-managers',
    label: 'Follow up and coordination department manager',
    icon: 'Share2Icon',
    component: FollowUpManagersTab,
  },
  {
    key: 'audit-team',
    label: 'Audit Team',
    icon: 'ShieldIcon',
    component: AuditTeamTab,
  },
  {
    key: 'technical-reviewers',
    label: 'Technical Reviewers',
    icon: 'ToolIcon',
    component: TechnicalReviewersTab,
  },
]

export default ASSIGN_PERSONAL_TABS
